import { RootReducer } from '../rootReducer';

const selectGuidesInfo = (state: RootReducer) => state.guides;

export { selectGuidesInfo };
